// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1lN6g","icon":"styles_icon__2oW5m"};